import React, { Component } from 'react';
import { Form, Button, Row, Col, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { createReturnOrder } from '../../containers/OrdersContainer/action';
import { appConfig } from '../../config';
import { toast, Flip } from 'react-toastify';
import './AddReturnOrderDrawer.css';


class AddReturnOrderDrawer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chemists: [],
            products: [],
            selectedChemist: '',
            selectedProducts: [], // For returns, this stores the list of items to be returned
            productSearchTerm: '',
            chemistSearchTerm: '',
            isLoadingChemists: false,
            isLoadingProducts: false,
            isChemistDropdownOpen: false,
            isProductDropdownOpen: false,
            isSubmitting: false,
            gstSlabs: [],


            // Fields for the current item being added
            currentItem: {
                item: null,
                purchaseInvoiceNo: '',
                purchaseDate: '',
                expiryDate: '',
                mrp: '',
                quantity: '',
                unitPrice: '',
                claimAmount: '',
                batchNo: '',
                taxPercentage: '',
                taxAmount: '',
                claimAmountWithTax: '',
                offer: '',
            }
        };

        this.typingTimeout = null;
        this.submitInProgress = false;
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && !prevProps.show) {
            this.setState({
                selectedChemist: '',
                selectedProducts: [],
                chemistSearchTerm: '',
                productSearchTerm: '',
                isChemistDropdownOpen: false,
                isProductDropdownOpen: false,
                currentItem: {
                    item: null,
                    purchaseInvoiceNo: '',
                    purchaseDate: '',
                    expiryDate: '',
                    mrp: '',
                    quantity: '',
                    unitPrice: '',
                    claimAmount: '',
                    batchNo: '',
                    taxPercentage: '',
                    taxAmount: '',
                    claimAmountWithTax: '',
                    offer: '',
                }
            });
            this.fetchChemists('');
            this.fetchProducts('');
            this.fetchGstSlabs();
        }
    }

    fetchGstSlabs = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${appConfig.ip}/gstMaster`, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = await res.json();
            if (res.ok) {
                this.setState({ gstSlabs: data.rows || data.data || data || [] });
            }
        } catch (error) {
            console.error('Failed to load GST slabs', error);
        }
    };


    fetchChemists = async (searchTerm = '') => {
        this.setState({ isLoadingChemists: true });
        try {
            const token = localStorage.getItem('token');
            const url = `${appConfig.ip}/users?role=chemist&search=${searchTerm}`;

            const res = await fetch(url, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = await res.json();
            if (res.ok) {
                this.setState({ chemists: data.rows || data.data || data || [] });
            }
        } catch (error) {
            console.error('Failed to load chemists', error);
        } finally {
            this.setState({ isLoadingChemists: false });
        }
    };

    fetchProducts = async (searchTerm = '') => {
        this.setState({ isLoadingProducts: true });
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${appConfig.ip}/itemMaster?limit=10&search=${searchTerm}`, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = await res.json();
            if (res.ok) {
                this.setState({ products: data.rows || data.data || data || [] });
            }
        } catch (error) {
            console.error('Failed to load products', error);
        } finally {
            this.setState({ isLoadingProducts: false });
        }
    };

    handleChemistSearchChange = (e) => {
        const value = e.target.value;
        this.setState({ chemistSearchTerm: value, selectedChemist: '' });

        if (this.typingTimeoutChemist) clearTimeout(this.typingTimeoutChemist);
        this.typingTimeoutChemist = setTimeout(() => {
            this.fetchChemists(value);
        }, 500);
    };

    handleChemistSelect = (chemist) => {
        const name = chemist.orgName || `${chemist.name} ${chemist.lName || ''}`;
        this.setState({
            selectedChemist: chemist.id || chemist._id,
            chemistSearchTerm: name,
            isChemistDropdownOpen: false,
        });
    };

    handleProductSearchChange = (e) => {
        const value = e.target.value;
        this.setState({ productSearchTerm: value });

        if (this.typingTimeout) clearTimeout(this.typingTimeout);
        this.typingTimeout = setTimeout(() => {
            this.fetchProducts(value);
        }, 500);
    };

    handleProductSelect = (product) => {
        this.setState({
            currentItem: {
                ...this.state.currentItem,
                item: product,
                // Do not auto-fill mrp, unitPrice, batchNo, or expiryDate as requested
                unitPrice: '',
                batchNo: '',
                expiryDate: '',
                mrp: '',
                taxPercentage: '',
                taxAmount: '',
                claimAmountWithTax: '',
                offer: '',
            },
            productSearchTerm: product.drugName || product.itemName || product.name,
            isProductDropdownOpen: false,
        });
    };


    handleCurrentItemChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => {
            const updatedItem = { ...prevState.currentItem, [name]: value };

            // Auto-calculate claim amount, tax amount and total amount
            if (name === 'quantity' || name === 'unitPrice' || name === 'taxPercentage') {
                const qty = parseFloat(name === 'quantity' ? value : prevState.currentItem.quantity) || 0;
                const price = parseFloat(name === 'unitPrice' ? value : prevState.currentItem.unitPrice) || 0;
                const baseAmnt = qty * price;

                const taxPercent = parseFloat(name === 'taxPercentage' ? value : prevState.currentItem.taxPercentage) || 0;
                const taxAmnt = (baseAmnt * taxPercent) / 100;

                updatedItem.taxAmount = taxAmnt.toFixed(2);
                updatedItem.claimAmount = (baseAmnt).toFixed(2);
                updatedItem.claimAmountWithTax = (baseAmnt + taxAmnt).toFixed(2);
            }

            return { currentItem: updatedItem };
        });
    };


    addItemToList = () => {
        const { currentItem, selectedProducts } = this.state;

        // Basic mandatory check
        if (!currentItem.item || !currentItem.quantity || !currentItem.unitPrice || !currentItem.purchaseDate || !currentItem.expiryDate || !currentItem.batchNo || !currentItem.purchaseInvoiceNo || !currentItem.taxPercentage) {
            toast.error('Please fill all mandatory fields for the item', { autoClose: 3000, transition: Flip });
            return;
        }

        // Validation: Offer must be less than 50 characters
        if (currentItem.offer && currentItem.offer.length > 50) {
            toast.error('Offer must be less than 50 characters', { autoClose: 3000, transition: Flip });
            return;
        }


        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const purchaseDate = new Date(currentItem.purchaseDate);
        const expiryDate = new Date(currentItem.expiryDate);

        // Validation: Purchase Date cannot be in the future
        if (purchaseDate > today) {
            toast.error('Purchase date cannot be in the future', { autoClose: 3000, transition: Flip });
            return;
        }

        // Validation: Expiry Date rules based on returnType
        const dateThreeMonthsFuture = new Date(today);
        dateThreeMonthsFuture.setMonth(dateThreeMonthsFuture.getMonth() + 3);

        const dateSixMonthsPast = new Date(today);
        dateSixMonthsPast.setMonth(dateSixMonthsPast.getMonth() - 6);

        if (this.props.returnType === 'return') {
            // Sales Return: Must be at least 3 months in the future
            if (expiryDate < dateThreeMonthsFuture) {
                toast.error('For Sales Return, expiry date must be more than 3 months from current date', { autoClose: 3000, transition: Flip });
                return;
            }
        } else {
            // Expiry Return: Must be within [6 months past, 3 months future)
            if (expiryDate < dateSixMonthsPast) {
                toast.error('For Expiry Return, expiry date cannot be more than 6 months old', { autoClose: 3000, transition: Flip });
                return;
            }
            if (expiryDate >= dateThreeMonthsFuture) {
                toast.error('For Expiry Return, expiry date must be less than 3 months from current date', { autoClose: 3000, transition: Flip });
                return;
            }
        }

        this.setState({
            selectedProducts: [...selectedProducts, { ...currentItem }],
            currentItem: {
                item: null,
                purchaseInvoiceNo: '',
                purchaseDate: '',
                expiryDate: '',
                mrp: '',
                quantity: '',
                unitPrice: '',
                claimAmount: '',
                batchNo: '',
                taxPercentage: '',
                taxAmount: '',
                claimAmountWithTax: '',
                offer: '',
            },
            productSearchTerm: ''
        });
    };


    handleRemoveProduct = (index) => {
        const { selectedProducts } = this.state;
        const nextProducts = selectedProducts.filter((_, i) => i !== index);
        this.setState({ selectedProducts: nextProducts });
    };

    handleSubmit = async (event) => {
        if (event) event.preventDefault();
        if (this.submitInProgress || this.state.isSubmitting) return;

        const { selectedChemist, selectedProducts, chemists } = this.state;
        const { returnType } = this.props;

        if (!selectedChemist) {
            toast.error('Please select a chemist', { autoClose: 3000, transition: Flip });
            return;
        }
        if (selectedProducts.length === 0) {
            toast.error('Please add at least one item to the return', { autoClose: 3000, transition: Flip });
            return;
        }

        this.submitInProgress = true;
        this.setState({ isSubmitting: true });
        try {
            const token = localStorage.getItem('token');
            const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
            const distributorId = userDetails.role === 'employee' ? userDetails.distributor : userDetails.id;
            const distributorName = userDetails.orgName || userDetails.name || '';

            const chemistData = chemists.find(c => (c.id || c._id) === selectedChemist) || {};
            const chemistName = chemistData.orgName || `${chemistData.name} ${chemistData.lName || ''}`;

            // Calculate totals for the entire order
            const totalClaimAmount = selectedProducts.reduce((acc, curr) => acc + (parseFloat(curr.claimAmount) || 0), 0);
            const totalTaxAmount = selectedProducts.reduce((acc, curr) => acc + (parseFloat(curr.taxAmount) || 0), 0);
            const totalClaimWithTax = selectedProducts.reduce((acc, curr) => acc + (parseFloat(curr.claimAmountWithTax) || 0), 0);

            const orderData = {
                orgType: "chemist",
                orderTrk: "normal",
                orderFrom: selectedChemist,
                orderFromName: chemistName,
                orderTo: distributorId,
                orderToName: distributorName,
                orderType: returnType, // "return" or "expiryReturn" as requested
                returnType: returnType,
                payType: "payLater",
                status: "created",
                hasCreated: false,
                addr: '',
                city: '',
                pincode: '',
                totalClaimAmount: totalClaimAmount,
                taxAmount: totalTaxAmount,
                claimAmountWithTax: totalClaimWithTax,
                orderDetail: {
                    claimAmount: totalClaimAmount,
                    taxAmount: totalTaxAmount,
                    claimAmountWithTax: totalClaimWithTax
                }
            };

            // Fetch Chemist Address Details
            try {
                const orgRes = await fetch(`${appConfig.ip}/orgProf/${selectedChemist}`, {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + token,
                    },
                });
                if (orgRes.ok) {
                    const orgData = await orgRes.json();
                    orderData.addr = orgData.addr1 || '';
                    orderData.city = orgData.city || '';
                    orderData.pincode = orgData.zip || '';
                }
            } catch (err) {
                console.error("Failed to fetch chemist profile", err);
            }

            // Dispatch Redux Action instead of direct fetch
            this.props.createReturnOrder({
                orderdata: orderData,
                itemData: selectedProducts
            });

            // The saga handles the success toast and navigation if needed.
            // We can close the drawer if we assume the action is triggered.
            // In a better implementation, we'd wait for success in props, but this matches the "functional" request.
            this.props.onClose();

        } catch (error) {
            toast.error('Failed to initiate return: ' + error.message, { autoClose: 3000, transition: Flip });
        } finally {
            this.submitInProgress = false;
            this.setState({ isSubmitting: false });
        }
    };

    render() {
        const { show, onClose, returnType } = this.props;
        const {
            chemists,
            products,
            selectedChemist,
            productSearchTerm,
            chemistSearchTerm,
            selectedProducts,
            isChemistDropdownOpen,
            isProductDropdownOpen,
            currentItem,
            isSubmitting
        } = this.state;

        return (
            <>
                <div className={`add-return-drawer-overlay ${show ? 'open' : ''}`} onClick={onClose}></div>
                <div className={`add-return-drawer ${show ? 'open' : ''}`}>
                    <div className="drawer-header">
                        <h5>Create {returnType === 'return' ? 'Purchase' : 'Expiry'} Return</h5>
                        <button className="close-btn" onClick={onClose}>&times;</button>
                    </div>

                    <div className="drawer-body">
                        <Form onSubmit={this.handleSubmit}>
                            <Form.Group>
                                <Form.Label>Select Chemist <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Search chemist..."
                                    value={chemistSearchTerm}
                                    onChange={this.handleChemistSearchChange}
                                    onFocus={() => this.setState({ isChemistDropdownOpen: true })}
                                    onBlur={() => setTimeout(() => this.setState({ isChemistDropdownOpen: false }), 200)}
                                    disabled={selectedProducts.length > 0}
                                />
                                {isChemistDropdownOpen && chemists.length > 0 && (
                                    <div className="dropdown-list">
                                        {chemists.map((c, i) => (
                                            <div key={i} className="dropdown-item" onClick={() => this.handleChemistSelect(c)}>
                                                {c.orgName || `${c.name} ${c.lName || ''}`}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </Form.Group>

                            <div className="item-selection-box mt-3 p-3 border rounded bg-light">
                                <h6>Add Item Details</h6>
                                <Form.Group>
                                    <Form.Label>Search product <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Search product..."
                                        value={productSearchTerm}
                                        onChange={this.handleProductSearchChange}
                                        onFocus={() => this.setState({ isProductDropdownOpen: true })}
                                        onBlur={() => setTimeout(() => this.setState({ isProductDropdownOpen: false }), 200)}
                                    />
                                    {isProductDropdownOpen && products.length > 0 && (
                                        <div className="dropdown-list">
                                            {products.map((p, i) => (
                                                <div key={i} className="dropdown-item" onClick={() => this.handleProductSelect(p)}>
                                                    {p.drugName || p.itemName || p.name}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </Form.Group>

                                {currentItem.item && (
                                    <Row className="mt-2">
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Batch No <span className="text-danger">*</span></Form.Label>
                                                <Form.Control name="batchNo" value={currentItem.batchNo} onChange={this.handleCurrentItemChange} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Purchase Inv No <span className="text-danger">*</span></Form.Label>
                                                <Form.Control name="purchaseInvoiceNo" value={currentItem.purchaseInvoiceNo} onChange={this.handleCurrentItemChange} />
                                            </Form.Group>
                                        </Col>

                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Purchase Date <span className="text-danger">*</span></Form.Label>
                                                <Form.Control type="date" name="purchaseDate" value={currentItem.purchaseDate} onChange={this.handleCurrentItemChange} max={new Date().toISOString().split('T')[0]} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Expiry Date <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    name="expiryDate"
                                                    value={currentItem.expiryDate}
                                                    onChange={this.handleCurrentItemChange}
                                                    min={(() => {
                                                        const d = new Date();
                                                        if (returnType === 'return') {
                                                            d.setMonth(d.getMonth() + 3);
                                                        } else {
                                                            d.setMonth(d.getMonth() - 6);
                                                        }
                                                        return d.toISOString().split('T')[0];
                                                    })()}
                                                    max={(() => {
                                                        if (returnType === 'expiryReturn') {
                                                            const d = new Date();
                                                            d.setMonth(d.getMonth() + 3);
                                                            // Should be strictly less than 3 months, so subtract one day for the 'max' attribute
                                                            d.setDate(d.getDate() - 1);
                                                            return d.toISOString().split('T')[0];
                                                        }
                                                        return undefined;
                                                    })()}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>MRP</Form.Label>
                                                <Form.Control type="number" name="mrp" value={currentItem.mrp} onChange={this.handleCurrentItemChange} />
                                            </Form.Group>
                                        </Col>


                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Quantity <span className="text-danger">*</span></Form.Label>
                                                <Form.Control type="number" name="quantity" value={currentItem.quantity} onChange={this.handleCurrentItemChange} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Unit Price <span className="text-danger">*</span></Form.Label>
                                                <Form.Control type="number" name="unitPrice" value={currentItem.unitPrice} onChange={this.handleCurrentItemChange} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={12}>
                                            <Form.Group>
                                                <Form.Label>Total Amount</Form.Label>
                                                <Form.Control type="number" name="claimAmount" value={currentItem.claimAmount} onChange={this.handleCurrentItemChange} readOnly />
                                            </Form.Group>
                                        </Col>

                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>GST Percentage <span className="text-danger">*</span></Form.Label>
                                                <Form.Control as="select" name="taxPercentage" value={currentItem.taxPercentage} onChange={this.handleCurrentItemChange}>
                                                    {currentItem.taxPercentage === "" && <option value="">-- Select GST % --</option>}
                                                    {this.state.gstSlabs.filter(s => s.status === "active").map((slab, i) => (
                                                        <option key={i} value={slab.taxPercentage}>{slab.label || slab.taxPercentage + '%'}</option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>GST Amount</Form.Label>
                                                <Form.Control type="number" name="taxAmount" value={currentItem.taxAmount} onChange={this.handleCurrentItemChange} readOnly />
                                            </Form.Group>
                                        </Col>

                                        <Col md={12}>
                                            <Form.Group>
                                                <Form.Label>Claim Amount</Form.Label>
                                                <Form.Control type="number" name="claimAmountWithTax" value={currentItem.claimAmountWithTax} onChange={this.handleCurrentItemChange} readOnly />
                                            </Form.Group>
                                        </Col>
                                        <Col md={12}>
                                            <Form.Group>
                                                <Form.Label>Offer (Max 50 characters)</Form.Label>
                                                <Form.Control as="textarea" name="offer" value={currentItem.offer} onChange={this.handleCurrentItemChange} rows={2} maxLength={50} />
                                            </Form.Group>
                                        </Col>


                                        <Col md={12} className="mt-3">
                                            <Button type="button" variant="info" block onClick={this.addItemToList}>Add Item to List</Button>
                                        </Col>

                                    </Row>
                                )}
                            </div>

                            {selectedProducts.length > 0 && (
                                <div className="selected-items-table mt-4">
                                    <h6>Return Items List</h6>
                                    <div className="table-responsive">
                                        <Table striped bordered hover size="sm">
                                            <thead>
                                                <tr>
                                                    <th>Item</th>
                                                    <th>Qty</th>
                                                    <th>Claim</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedProducts.map((p, idx) => (
                                                    <tr key={idx}>
                                                        <td>{p.item.drugName || p.item.itemName || p.item.name}</td>
                                                        <td>{p.quantity}</td>
                                                        <td>{p.claimAmount}</td>
                                                        <td>
                                                            <Button type="button" variant="link" className="text-danger p-0" onClick={() => this.handleRemoveProduct(idx)}>
                                                                <i className="fa fa-trash"></i>
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            )}
                        </Form>
                    </div>

                    <div className="drawer-footer">
                        <Button type="button" variant="secondary" onClick={onClose} disabled={isSubmitting}>Cancel</Button>
                        <Button type="button" variant="primary" onClick={this.handleSubmit} disabled={isSubmitting} className="ml-2">
                            {isSubmitting ? 'Submitting...' : 'Create Return'}
                        </Button>
                    </div>
                </div>
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    createReturnOrder: (data) => dispatch(createReturnOrder(data))
});

export default connect(null, mapDispatchToProps)(AddReturnOrderDrawer);
